import type { VoidComponent } from "solid-js";
import { PlayProgressBar, PlayProgressWrapper } from "./styled";

const PlayProgress: VoidComponent<{
	progress: number;
}> = (props) => {
	return (
		<PlayProgressWrapper flexShrink={1} h="6px">
			<PlayProgressBar style={{ width: `${props.progress * 100}%` }} />
		</PlayProgressWrapper>
	);
};
export default PlayProgress;
